<template>
<svg width="18" height="15" viewBox="0 0 18 15" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16.0617 0.565598L1.12349 6.35591C0.522351 6.62556 0.319028 7.16555 0.978197 7.45861L4.8105 8.6828L14.0765 2.9266C14.5825 2.56523 15.1004 2.66159 14.6547 3.05912L6.69646 10.302L6.44647 13.3672C6.67802 13.8405 7.10198 13.8427 7.37242 13.6075L9.5742 11.5133L13.3451 14.3517C14.2209 14.8728 14.6975 14.5365 14.8859 13.5812L17.3593 1.80902C17.6161 0.633175 17.1781 0.115087 16.0617 0.565598Z" fill="#773DBD"/>
</svg>
</template>
